import { compose, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import { googleAnalyticProductRemoveFromCart } from 'actions/googleAnalytic'
import { getGTMServiceData } from 'helpers/googleAnalytic'
import { addFreeAlignmentCheckToCart, removeFreeAlignmentCheckFromCart } from './actions'
import FreeAlignmentCheckBlock from './FreeAlignmentCheckBlock'
import { FREE_ALIGNMENT_SERVICE } from './constants'

const withCheckState = withState(
  'checked',
  'setCheck',
  ({ freeAligmentTooltip: { existInOrder }} = {}) => existInOrder === 'true'
)

const withLoadingState = withState('isLoading', 'setLoading', false)

const withFreeAlignmentActionHandlers = withHandlers({
  handleToggleCheck: ({
    setCheck,
    setLoading,
    addFreeAlignmentCheckToCart,
    removeFreeAlignmentCheckFromCart,
    googleAnalyticProductRemoveFromCart,
    freeAligmentTooltip: {
      commerceItemId
    },
    freeAligmentTooltip
  }) => async e => {
    setLoading(true)
    if (e.target.checked) {
      setCheck(true)
      await addFreeAlignmentCheckToCart(FREE_ALIGNMENT_SERVICE)
    } else {
      setCheck(false)
      await removeFreeAlignmentCheckFromCart(commerceItemId)
      googleAnalyticProductRemoveFromCart({ data: getGTMServiceData({ service: freeAligmentTooltip }) })
    }
    setLoading(false)
  }
})

export default compose(
  connect(null, {
    addFreeAlignmentCheckToCart,
    removeFreeAlignmentCheckFromCart,
    googleAnalyticProductRemoveFromCart
  }),
  withCheckState,
  withLoadingState,
  withFreeAlignmentActionHandlers
)(FreeAlignmentCheckBlock)
